import React, { FC, ReactNode } from 'react';
import { Container, Divider, Grid, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { ExpertiseCard } from 'components/atoms';

interface CardsProps {
  listContent: Array<{ title: string; image: string; link: string; icon: ReactNode }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(11),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(43),
    },
  },
  divider: {
    marginBottom: theme.spacing(6),
    height: 1,
    backgroundColor: theme.palette.primary.contrastText,
  },
  card: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
}));

const CardsSection: FC<CardsProps> = ({ listContent }) => {
  const classes = useStyles();
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Container className={classes.root} fixed>
      <Divider className={classes.divider} />
      <Grid container direction="row" justify="space-between" spacing={isSmall ? 5 : 0}>
        {listContent.map(({ title, icon, image, link }, index) => (
          <Grid xs={12} lg={6} className={classes.card} item key={index} data-aos="fade-up">
            <ExpertiseCard title={title} icon={icon} image={image} link={link} isCareerCard />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CardsSection;
